import { render, staticRenderFns } from "./ReservationFrequencyTypeBadge.vue?vue&type=template&id=41150422&scoped=true&"
import script from "./ReservationFrequencyTypeBadge.vue?vue&type=script&lang=js&"
export * from "./ReservationFrequencyTypeBadge.vue?vue&type=script&lang=js&"
import style0 from "./ReservationFrequencyTypeBadge.vue?vue&type=style&index=0&id=41150422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41150422",
  null
  
)

export default component.exports